// Top Workwear — Quote Cart
window.QuoteCart = {
  storageKey: 'tw_quote_cart',

  getCart() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    } catch { return []; }
  },

  saveCart(cart) {
    localStorage.setItem(this.storageKey, JSON.stringify(cart));
    document.dispatchEvent(new CustomEvent('quote-cart-updated', { detail: cart }));
  },

async addItem(name, handle, variantId, quantity) {
    const cart = this.getCart();
    const res = await fetch(`/products/${handle}.json`);
    const { product } = await res.json();
    const variants = product.variants.map(v => ({
      id: v.id,
      title: v.title,
      colour: product.options.length >= 1 ? v.option1 : null,
      size: product.options.length >= 2 ? v.option2 : null,
      option3: product.options.length >= 3 ? v.option3 : null,
      available: v.available
    }));

    const productOptions = product.options.map(o => o.name);

    // Build colour → image map using variant_ids
    const colourImageMap = {};
    product.images.forEach(img => {
      img.variant_ids.forEach(vid => {
        const variant = variants.find(v => v.id === vid);
        if (variant?.colour && !colourImageMap[variant.colour]) {
          colourImageMap[variant.colour] = img.src;
        }
      });
    });

    const selected = variants.find(v => v.id == variantId) || variants[0];
    const existing = cart.find(i =>
      i.handle === handle &&
      i.selectedColour === selected.colour &&
      i.selectedSize === selected.size &&
      i.selectedOption3 === (selected.option3 || '')
    );
    if (existing) {
      existing.quantity = String(parseInt(existing.quantity) + parseInt(quantity));
    } else {
      cart.push({
        name,
        handle,
        image: colourImageMap[selected.colour] || product.images?.[0]?.src || '',
        colourImageMap,
        variants,
        productOptions,
        selectedColour: selected.colour || '',
        selectedSize: selected.size || '',
        selectedOption3: selected.option3 || '',
        quantity: String(quantity)
      });
    }
    this.saveCart(cart);
  },



  removeItem(index) {
    const cart = this.getCart();
    cart.splice(index, 1);
    this.saveCart(cart);
  },

  clearCart() {
    this.saveCart([]);
  },

  getCount() {
    return this.getCart().length;
  },

  buildAppUrl() {
    const cart = this.getCart();
    const encoded = btoa(JSON.stringify(cart));
    return `https://admin.shopify.com/store/top-workwear1/apps/quote-manager-8?quoteCart=${encoded}`;
  }
};

// Update bubble
function updateQuoteBubble(count) {
  document.querySelectorAll('.quote-cart-count').forEach(el => {
    el.textContent = count;
    const bubble = el.closest('.cart-count-bubble');
    if (bubble) bubble.style.display = count > 0 ? '' : 'none';
  });
}

document.addEventListener('quote-cart-updated', (e) => {
  updateQuoteBubble(e.detail.length);
});

document.addEventListener('DOMContentLoaded', () => {
  updateQuoteBubble(window.QuoteCart.getCount());
});
